"use client"

// Lazy facade only - this chunk group is preloaded on every page (ACEB-214).
import { loadPosthog } from "../src/lib/posthog-lazy"
import NextError from "next/error"
import { useEffect } from "react"

export default function GlobalError({
    error,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        void loadPosthog().then((posthog) => {
            if (posthog?.__loaded) posthog.captureException(error)
        })
    }, [error])

    return (
        <html>
            <body>
                <NextError statusCode={0} />
            </body>
        </html>
    )
}
